import apiClient from "./axios"

// 🧾 Get all vehicle importers (with pagination, search, filter, sort)
export const getVehicleImporters = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-importers", { params })
  return data
}

// Get all vehicle importer stocks (with pagination, search, filter, sort)
export const getVehicleImporterStocks = async (params = {}) => {  
  const { importerId, ...queryParams } = params
  const { data } = await apiClient.get(`/vehicle-importers/${importerId}/stocks`, { params: queryParams })
  return data
}

// Get all vehicle importer group stocks (with pagination, search, filter, sort)
export const getVehicleImporterGroupStocks = async (params = {}) => {  
  const { importerId, ...queryParams } = params
  const { data } = await apiClient.get(`/vehicle-importers/${importerId}/grouped-stocks`, { params: queryParams })
  return data
}

// 🔍 Get a single importer by ID
export const getVehicleImporter = async (id) => {
  const { data } = await apiClient.get(`/vehicle-importers/${id}`)
  return data
}

// ➕ Create a new importer
export const createVehicleImporter = async (importerData) => {
  const { data } = await apiClient.post("/vehicle-importers", importerData)
  return data
}

// ✏️ Update importer by ID
export const editVehicleImporter = async ({ id, ...importerData }) => {
  const { data } = await apiClient.patch(`/vehicle-importers/${id}`, importerData)
  return data
}

// ❌ Delete importer by ID
export const deleteVehicleImporter = async (id) => {
  const { data } = await apiClient.delete(`/vehicle-importers/${id}`)
  return data
}
